import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const textFieldDefaultVariants = {
  "error": false,
  "disabled": false,
  "labelHidden": false
}
const textFieldCompoundVariants = []

const textFieldSlotNames = [
  [
    "container",
    "TextField__container"
  ],
  [
    "label",
    "TextField__label"
  ],
  [
    "input",
    "TextField__input"
  ],
  [
    "textarea",
    "TextField__textarea"
  ],
  [
    "error",
    "TextField__error"
  ]
]
const textFieldSlotFns = /* @__PURE__ */ textFieldSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, textFieldDefaultVariants, getSlotCompoundVariant(textFieldCompoundVariants, slotName))])

const textFieldFn = memo((props = {}) => {
  return Object.fromEntries(textFieldSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const textFieldVariantKeys = [
  "labelHidden",
  "error",
  "disabled"
]
const getVariantProps = (variants) => ({ ...textFieldDefaultVariants, ...compact(variants) })

export const textField = /* @__PURE__ */ Object.assign(textFieldFn, {
  __recipe__: false,
  __name__: 'textField',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: textFieldVariantKeys,
  variantMap: {
  "labelHidden": [
    "true"
  ],
  "error": [
    "true"
  ],
  "disabled": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, textFieldVariantKeys)
  },
  getVariantProps
})